// import store from '@/store';
// import { DELETE_METHOD, PUT_METHOD, Request } from '@/lib/http';
// import AuthEnum from '../lib/enums/auth-enum';
// import { sortByRecent } from '@/modules/formulary/utils/opportunity';
// import {
//   appendNote,
//   newOpportunityResource,
//   patchOpportunityResource,
//   toOpportunityRecord,
// } from './opportunityResource';
import {
  addOpportunityNote,
  createOpportunity,
  deleteOpportunity,
  getOpportunity,
  listOpportunities,
  updateOpportunity,
} from './opportunitiesLocalStore';

// Backed by a browser-local store until the medos `opportunities.v1.Opportunity` kind
// exists; each medos request is commented out beside it. See OPPORTUNITIES_DATA_CONTRACTS.md.

// const collectionURL = () =>
//   `/medos/api/t/${store.getters.tenant.id}/resources/opportunities/v1/opportunities`;
// const itemURL = (name) => `${collectionURL()}/${encodeURIComponent(name)}`;
// const send = (url, options = {}) => new Request(url, { authType: AuthEnum.TENANT, ...options }).send();
// const put = (resource) => send(itemURL(resource.meta.name), { method: PUT_METHOD, body: resource });
// const asResult = (resource) => ({ opportunity: toOpportunityRecord(resource) });

export default {
  list({ status } = {}) {
    // `status` is a server-generated label, so it filters with a label selector.
    // const query = status ? `?ls=${encodeURIComponent(`status:${status}`)}` : '';
    // return send(`${collectionURL()}${query}`).then(({ items }) => ({
    //   opportunities: sortByRecent((items || []).map(toOpportunityRecord)),
    // }));
    return listOpportunities({ status });
  },

  get(id) {
    // return send(itemURL(id)).then(asResult);
    return getOpportunity(id);
  },

  create(fields, actor) {
    // return put(newOpportunityResource(fields, actor)).then(asResult);
    return createOpportunity(fields, actor);
  },

  // Only the keys in `patch` change.
  update(id, patch) {
    // return send(itemURL(id))
    //   .then((resource) => put(patchOpportunityResource(resource, patch)))
    //   .then(asResult);
    return updateOpportunity(id, patch);
  },

  delete(id) {
    // `raw`: medos answers a delete with no body, which Request would fail to parse.
    // return send(itemURL(id), { method: DELETE_METHOD, raw: true }).then(() => ({ success: true }));
    return deleteOpportunity(id);
  },

  addNote(id, content, actor) {
    // return send(itemURL(id))
    //   .then((resource) => put(appendNote(resource, content, actor)))
    //   .then(asResult);
    return addOpportunityNote(id, content, actor);
  },
};
